/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StoreSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Footer_viewer$ref: FragmentReference;
declare export opaque type Footer_viewer$fragmentType: Footer_viewer$ref;
export type Footer_viewer = {|
  +footers: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +name: ?string,
        +urls: ?$ReadOnlyArray<?{|
          +name: ?string,
          +type: ?string,
          +url: ?string,
          +properties: ?string,
        |}>,
      |}
    |}>
  |},
  +$fragmentRefs: StoreSearch_viewer$ref,
  +$refType: Footer_viewer$ref,
|};
export type Footer_viewer$data = Footer_viewer;
export type Footer_viewer$key = {
  +$data?: Footer_viewer$data,
  +$fragmentRefs: Footer_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Footer_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "FooterConnection",
      "kind": "LinkedField",
      "name": "footers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FooterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Footer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FooterUrl",
                  "kind": "LinkedField",
                  "name": "urls",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "properties",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "footers(first:3)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StoreSearch_viewer"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7aa74dcf54bd3e2ac6e3adfa1c77acf';

module.exports = node;
